export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./registration-by-email-confirmation.vue?vue&type=template&id=cb252cf0"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/registration-by-email-confirmation.vue?vue&type=template&id=cb252cf0
// module id = iXSG
// module chunks = 0